/** A SAR amount without the sign: whole riyals without decimals, fractions with two ("29", "23.20", "1,188"). */
export function formatSarAmount(amount: number): string {
  const whole = Number.isInteger(Math.round(amount * 100) / 100)
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: whole ? 0 : 2,
  }).format(amount)
}
